import React from 'react';
import { CheckboxProps } from 'antd/lib';
import styled from 'styled-components';
import { Avatar, Checkbox } from 'antd';
import Box from 'components/Box';

const StaffCheckbox = ({ avatar, name, ...props }: CheckboxProps & { avatar: string, name: string }) => {
    return (
        <Container>
            <CheckboxStyled {...props} >
                <Box display='flex' gap='2' alignItems='center' justifyContent='center' flexDirection='column' width='100%'>
                    <Avatar src={avatar} size={87} >
                        {name?.[0] || 'A'}
                    </Avatar>
                    <EllipsisText className="checkbox-label-text">{name}</EllipsisText>
                </Box>
            </CheckboxStyled>
        </Container>
    );
};

export default StaffCheckbox;

const Container = styled.div`
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 8px;
    transition: all 0.3s ease;
    &:hover {
        .ant-checkbox-wrapper {
            .ant-checkbox-wrapper-checked {
                opacity: 0.8;
            }
        }
        &:not(.ant-checkbox-wrapper-checked) {
            background: #e0e0e0;
            opacity: 0.8;
        }
    }
`;

const EllipsisText = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 120px;
    width: 100%;
    text-align: center;
`;

const CheckboxStyled = styled(Checkbox)`
    width: 100%;
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    .checkbox-label-text {
        color: #1D2129;
        font-family: Poppins;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 30px; /* 166.667% */
        text-transform: capitalize;
    }

    .ant-checkbox-inner:after {
        top: 48%
    }
    &.ant-checkbox-wrapper {
        flex-direction: column;
    }
    &.ant-checkbox-wrapper:after {
        display: none;
    }
    .ant-checkbox {
        display: none;
    }
    &.ant-checkbox-wrapper-checked {
        .ant-checkbox {
            display: block;
            position: absolute;
            top: 8px;
            right: 8px;
        }
        border-radius: 8px;
        background: #C6E9EF;
        .checkbox-label-text {
        color: #2D6772 !important;
        }
    }
`;